
<button type="button" class="btn btn-sm btn-info" (click)="showPopup()"><span class="glyphicon glyphicon-envelope"></span> Login Daten erzeugen</button>

<dx-popup class="popup"
          title="Träger-Zugangsdaten erstellen und senden"
          [height]="'auto'"
          [width]="'50%'"
          [showTitle]="true"
          [(visible)]="popupVisible"
          (onShowing)="onShowing($event)"
          style="display: inline-block;">

  <div *dxTemplate="let data of 'content'">
    <dx-form [formData]="formData" #dataForm>

      <dxi-item dataField="name" [label]="{text: 'Name'}">
        <dxi-validation-rule type="required" message="Bitte einen Name angeben"></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="vorname" [label]="{text: 'Vorname'}">
        <dxi-validation-rule type="required" message="Bitte einen Vorname angeben"></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="email" [label]="{text: 'Email'}">
        <dxi-validation-rule type="required" message="Bitte eine Email angeben"></dxi-validation-rule>
        <dxi-validation-rule type="email" message="Bitte eine valide Email angeben"></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="telefon" [label]="{text: 'Telefon'}">
      </dxi-item>

    </dx-form>
  </div>

  <dxi-popup-toolbar-item location="before"
                    [visible]="loading"
                    toolbar="bottom">
    <div *dxTemplate>
      <span class="text-danger">Bitte warten, Daten werden gesendet.</span>
    </div>
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            disabled: loading,
            text: 'Senden',
            onClick: onClickSend
        }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Abbrechen',
            onClick: onClickClose
        }">
  </dxi-popup-toolbar-item>
</dx-popup>
